import React, { FC } from 'react';

import { GenExternalLink, GenNavTile } from '@/components';
import { TypeAccountNavTileFields } from '@/core/generated-types';

import { TypeMyAccountPageTranslations } from '@/utils/translations';
import { getLocaleDomain } from '@/utils/helpers';
import {
  CLICKED_ITEM_TYPES,
  CTA_NAMES,
  PAGE_LOCATIONS,
  trackItemClickedEvent,
} from '@/utils/rudderstack';

export type ReadingSkillSetTileProps = {
  t: TypeMyAccountPageTranslations;
  tile: TypeAccountNavTileFields;
  hasSkillSets: boolean;
};

const ReadingSkillSetTile: FC<ReadingSkillSetTileProps> = ({
  t,
  tile,
  hasSkillSets,
}) => {
  if (!hasSkillSets) return null;

  const baseUrl = getLocaleDomain('US');
  const rssLink = `${baseUrl}/account/reading-skill-set`;

  const sendItemClickedEvent = () => {
    trackItemClickedEvent({
      url: rssLink,
      type: CLICKED_ITEM_TYPES.LINK,
      pageLocation: PAGE_LOCATIONS.READING_SKILL_SET,
      cta: CTA_NAMES.VIEW,
    });
  };

  return (
    <GenNavTile
      title={tile.title}
      description={tile.description}
      titleDecorator={
        <GenExternalLink
          href={rssLink}
          cta={t.viewCta}
          onClick={sendItemClickedEvent}
        />
      }
    />
  );
};

export default React.memo(ReadingSkillSetTile);
